import React from 'react';

const Hero = () => {
  // Função para criar o link do WhatsApp
  const createWhatsAppLink = (message) => {
    const phoneNumber = "5537998630380"; // Adicionando o código do país (55) antes do número
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  };

  return (
    <section className="bg-primary-black text-primary-white py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
            Rompa ciclos. Reconstrua sua história emocional.
            <br />
            <span className="text-accent-red">Proclame liberdade à sua mente cativa.</span>
          </h1>
          <p className="text-xl md:text-2xl mb-12 font-light">
            Um processo terapêutico profundo, humanizado e autoral, para quem busca verdadeira transformação emocional.
            <br />
            <span className="text-sm mt-4 block text-gray-300">+2 mil atendimentos realizados | +4 mil membros em comunidades | Livro em construção.</span>
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <a 
              href={createWhatsAppLink("Olá, gostaria de agendar minha sessão terapêutica.")} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-accent text-lg px-8 py-4"
            >
              AGENDAR MINHA SESSÃO
            </a>
            <a 
              href={createWhatsAppLink("Olá, gostaria de agendar uma palestra com Kelton Oliveira.")} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn text-lg px-8 py-4 bg-transparent border border-white text-white hover:bg-white hover:text-black transition-all duration-300"
            >
              AGENDE UMA PALESTRA
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
